import * as React from 'react';
import * as L from 'leaflet';

export const LeafletContext = React.createContext<[L.Map | null, React.Dispatch<React.SetStateAction<L.Map | null>>] | null>(null);

export function leafletContext<P>(Component: React.FC<P>) {
  
  return (props: P) => {
    const contextDispatch = React.useState<L.Map | null>(null);
    return (<LeafletContext.Provider value={contextDispatch}>
      <Component {...props} />
    </LeafletContext.Provider>);
  }
}

export const LeafletTooltipContext = React.createContext<L.Layer | null>(null);